import { deploymentsApi, ValidationResult } from '../api/deploymentsApi';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

export const useValidateDeploymentCSV = (
  deploymentId: string,
  options: DeploymentMutationOptions<ValidationResult> = {}
) =>
  useDeploymentMutation<File, ValidationResult>({
    mutationFn: (file) => deploymentsApi.validateCSV(deploymentId, file),
    errorLabel: 'Error validating CSV',
    ...options,
  });
